import Banner from "./components/Banner/Banner";
import Services from "./components/Services/Services";
import Contacts from "./components/Contacts/Contacts";
import About from "./components/About/About";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Testemonials from "./components/Testemonials/Testemonials";
import ScrollToTop from 'react-scroll-to-top';
import { FiChevronUp } from "react-icons/fi";
import { ToastContainer } from "react-toastify";

const App = () => {
    return (
        <div className="App">
            <Header />
            <div className="application_wrapper">
                <Banner />
                <About />
                <Services />
                <Testemonials />
                <Contacts />
            </div>
            <div className="backto-top">
                <ScrollToTop smooth component={<FiChevronUp />}></ScrollToTop>
            </div>
            <Footer />
            <ToastContainer />
        </div>
    );
}

export default App;
